import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ShopContextProvider from "./components/context/ShopContext";
import UserProvider from "./components/context/UserContext";
import { AddressProvider } from "./components/context/AddressContext";
import { WishlistProvider } from "./components/context/WishlistContext";
import { CartProvider } from "./components/context/CartContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <AddressProvider>
        <ShopContextProvider>
          <CartProvider>
            <WishlistProvider>
              <App />
            </WishlistProvider>
          </CartProvider>
        </ShopContextProvider>
      </AddressProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
